<template>
  <article 
    class="invitation" 
    style="position: relative;">

    <div 
      class="invitation__header_selector" 
      v-if="isMobile" 
      ref="contentHeader">
      <div 
        class="invitation__dates_selector"
        v-for="date of dates" 
        :key="date.key" 
        @click="goToDate(date.key)">
        <span style="font-weight: 600">{{date.weekDay}}</span>
        <span>{{date.day}}</span>
      </div>
    </div>

    <div 
      v-if="!isMobile" 
      class="invitation__cards_container">
      <div class="invitation__cards_container_header">
        <div class="invitation__cards_container_header_options">
          <span 
            v-for="option of headerOptions" 
            :key="option.id" 
            @click="selectState(option.id)"
            :class="[{'invitation__cards_container_header_selected_option': option.id === selectedState}]">
            <span :class="option.class"></span>{{ option.title }}</span>
        </div>
        <div style="display: flex; align-items: center;">
        <div 
          class="invitation__select_container" 
          style="display: flex; align-items: center;" 
          v-if="!(getUserRoles().includes('Counter') || getUserRoles().includes('counter'))">
          <div style="width: 30px; height: 30px;  margin-left: 1rem;"><BuildingIcon color="#3c3c3c"/></div>
            <v-select 
              solo 
              flat 
              v-model="selectedLocation" 
              :items="locations" 
              item-text="name" 
              item-value="id"></v-select>
        </div>
        <div v-else style="min-height: 62px;"></div>
          <v-tooltip bottom v-if="getUserRoles().includes('Counter') || getUserRoles().includes('counter')">
            <template v-slot:activator="{on}">
              <span 
                @click="onModalOpen" 
                v-on="on" 
                style="margin-left: 1rem; width: 40px; height: 40px; display: block; cursor: pointer;"><AddIcon color="#3f74bf"/></span>
            </template>
            <span>Crear Invitación</span>
          </v-tooltip>
        </div>
      </div>
      <div class="invitation__cards_container_body">
        <div class="invitation__invitation_types">
          <div 
            class="invitation__types_chips" 
            v-for="type of invitationTypes" 
            :key="type.id">
            <v-checkbox 
              :label="type.title" 
              v-model="type.selected"></v-checkbox>
          </div>
        </div>
        <span v-if="selectedState === 1">Invitationes por aprobar</span>
        <span v-else-if="selectedState === 2">Visitantes activos</span>
        <span v-else-if="selectedState === 3">Visitas cerradas</span>
        <span v-else>Invitaciones activas</span>
        <div class="invitation__cards_body">
          <div 
            @click="showData(invitation)" 
            class="invitation__card" 
            v-for="invitation of invitations" 
            :key="invitation.id">
            <div :class="['invitation__card_header', {'invitation__card_header--blue': selectedState === 1}, {'invitation__card_header--gray': selectedState !== 1}]">
              <p>{{ invitation.location }}</p>
              <span :class="['invitation__circle', {'invitation__blue_circle': selectedState === 1}, {'invitation__green_circle': selectedState === 2}, {'invitation__red_circle': selectedState === 3}]"></span>
            </div>
            <div class="invitation__card_body">
              <div class="invitation__card_info">
                <div class="invitation__card_general_info">
                  <div 
                    v-if="invitation.rut" 
                    class="invitation__card_rut"> {{ invitation.rut }} <span v-if="selectedState === 1" class="invitation__card_rut_button" @click="copyRut(invitation.rut, $event)">copiar</span></div>
                  <div class="invitation__card_name">{{ invitation.name }}</div>
                  <div 
                    v-if="!invitation.rut" 
                    class="invitation__card_not_rut">
                    <span>No. Documento</span>
                    <span class="invitation__bottom_line"></span>
                  </div>
                </div>
                <div class="invitation__card_user_photo">
                  <div 
                    class="invitation__card_user_photo_field" 
                    :style="{'background-image': `url(${invitation.photo})`}"></div>
                </div>
              </div>
              <div class="invitation__card_dates">
                <div><span><EntryIcon/></span>{{ invitation.date_from }}</div>
                <div><span><ExitIcon/></span>{{ invitation.date_until }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      v-if="isMobile && positioned" class="cards-container" 
      :style="{'padding-top': `${dividerHeader}px!important`}">
      <div 
        v-for="dateKey of dates" 
        :key="dateKey.key" 
        :id="dateKey.key">
        <h6 style="border-bottom: unset"></h6>
        <div 
          class="card" 
          style="position: relative;" 
          v-for="invitation of gropuedInvitations[dateKey.key]" 
          :key="invitation.id">
          <div 
            style="position: absolute; right: 1px; top: 1px; width: 104px; height: 100%; padding: 1rem; background: #28c937;" 
            @click="openModalApprove(invitation)">
            <ApproveIcon :color="'white'"/>
          </div>
          <div 
            style="position: absolute; left: 1px; top: 1px; height: 100%; width: 104px; padding: 1rem; background: #ff4040;" 
            @click="openModalDeny(invitation)">
            <DeleteIcon :color="'white'"/>
          </div>
          <div 
            class="card-content"
            @click="showData(invitation)"
            :key="invitation.id" 
            v-swipe="{threshold: 104, active: getUserType() === 'Admin' && getUserInfoType() === 'Admin' || getUserIsApprover()}">
            <div style="display: flex; width: 100%; position: relative">
              <div 
                v-if="invitation.photo" 
                style="border-radius: 50%; width: 72px; height: 72px; background-position: 0; background-size: cover; margin-right: 1rem" 
                :style="{'background-image': `url(${invitation.photo})`}"></div>
              <div 
                v-else 
                style="border-radius: 50%; width: 72px; height: 72px; background-position: 0; background-size: cover; margin-right: 1rem; border: solid 1px #b8b8b8;"></div>
              <div style="width: calc(100% - 104px);">
                <div style="display: flex; width: 100%; justify-content: space-between">
                  <p style=" white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100%;
                        color: black;
                        display: block;">{{invitation.name}}</p>
                  <p style="white-space: nowrap; color: black;">{{ invitation.rut ? invitation.rut : 'N/A' }}</p>
                </div>
                <p style="color: black; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ invitation.invited_type? invitation.invited_type.name : '______' }}</p>
                <p style="color: black; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{invitation.description}}</p>
              </div>
            </div>
            <p style="position: absolute; right: 3px; bottom: 3px; font-size: 12px!important; color: #3f74bf;">{{invitation.location}}</p>
            <p style="position: absolute; right: 3px; top: 3px; font-size: 12px!important; color: #3f74bf;">{{invitation.date_from}}</p>
          </div>
        </div>
      </div>

    </div>

    <div v-if="totalItems > 24">
      <v-pagination :length="totalPages" @input="updatePagination" v-model="selectedPage"></v-pagination>
    </div>

    <v-dialog 
      v-model="modal_approve" 
      max-width="500px">
      <v-card>
        <div class="invitation__new">
          <div class="invitation__new--title">
            <div class="invitation__new--photo_preview">
              <label class="invitation__new--label"
              >¿Seguro deseas aprobar esta invitación?</label
              >
            </div>
          </div>
          <div class="invitation__new--actions">
            <v-btn @click="modal_approve = false">NO</v-btn>
            <v-btn
                color="info"
                @click="approveInvitation()"
            >SI
            </v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog 
      persistent 
      v-if="showInvitation" 
      content-class="custom-dialog" 
      v-model="modal_info" :max-width="isMobile ? '100%' : '95%'" 
      :max-height="isMobile ? '95%' : '85%'">

      <div class="invitation__dialog">
        <div class="invitation__dialog_header">
          <div 
            @click="closeData" 
            v-if="!isMobile" 
            class="invitation__dialog_close">
            <span></span> Cerrar
          </div>
          <div 
            v-else 
            style="cursor: pointer; font-size: 22px; color: white;" 
            @click="closeData">
            <
          </div>
          <span 
            v-if="!isMobile" 
            class="invitation__dialog_title">{{ showInvitation.location }}</span>
          <span 
            v-else 
            class="invitation__dialog_title">Aprobaciones</span>
          <div>
            <span 
              v-if="selectedState === 1" 
              class="invitation__circle invitation__blue_circle"></span>
            <span 
              v-if="selectedState === 2" 
              class="invitation__circle invitation__green_circle"></span>
            <span 
              v-if="selectedState === 3" 
              class="invitation__circle invitation__red_circle"></span>
            <span 
              v-if="selectedState === 4" 
              class="invitation__circle"></span>
          </div>
        </div>
        <v-stepper v-model="steps">
          <v-stepper-header>
            <div v-for="(step, index) in steps">
              <v-stepper-step
                :complete="step.state == 'Complete'" 
                :step="''"
                :color="step.state === 'Cancelled' ? 'red' : 'green'">
                {{step.name}}
              </v-stepper-step>
            </div>
          </v-stepper-header>
        </v-stepper>
        <div class="invitation__dialog_general_container">
          <div class="invitation__dialog_body">
            <div class="invitation__dialog_body_left">
              <div class="invitation__dialog_card mb_1">
                <div class="invitation__dialog_body_photo_field">
                  <div 
                    class="invitation__dialog_user_photo mb_1" 
                    :style="{'background-image': `url(${showInvitation.photo})`}"></div>
                  <div 
                    class="invitation__dialog_user_info" 
                    v-if="!isMobile">
                    <span class="invitation__dialog_name">{{ showInvitation.name ? showInvitation.name : '' }}</span>
                    <span class="invitation__dialog_rut mb_1">{{ showInvitation.rut || 'N/A' }} <span style="font-size: 14px;
                                                                                                            border: solid 1px #b8b8b8;
                                                                                                            color: #b8b8b8;
                                                                                                            padding: 0.5rem;
                                                                                                            border-radius: 22px;
                                                                                                            cursor: pointer;" v-if="!isMobile && showInvitation.rut" @click="copyRut(showInvitation.rut, $event)">Copiar</span></span>

                  </div>
                  <div 
                    v-else 
                    class="invitation__dialog_user_info">
                    <span style="color: black;">Nombre: </span>
                    <span class="invitation__dialog_name">{{ showInvitation.name ? showInvitation.name : '' }}</span>
                    <span style="color: black;">Documento: </span>
                    <span class="invitation__dialog_rut">{{ showInvitation.rut || 'N/A' }}</span>
                  </div>
                </div>
                <div 
                  v-if="isMobile && showInvitation.rut" 
                  style="width: 100%; display: flex; justify-content: flex-end; border-top: solid 1px #b8b8b8; padding: 1rem 0" >
                  <span 
                    style="background: #d8e2f5; padding: 0.4rem; color: #3f74bf; border-radius: 5px" 
                    @click="copyRut(showInvitation.rut, $event)">Copiar</span>
                </div>
              </div>
              <div 
                class="invitation__dialog_card mb_1" 
                v-if="!isMobile">
                <span class="invitation__dialog_dates mb_1 invitation__dialog_date"><span class="invitation__dialog_icon"><EntryIcon/></span>{{ showInvitation.date_from ? showInvitation.date_from : '' }}</span>
                <span class="invitation__dialog_dates invitation__dialog_date"><span class="invitation__dialog_icon"><ExitIcon/></span>{{ showInvitation.date_until ? showInvitation.date_until : '' }}</span>
              </div>
              <div 
                v-if="!isMobile && ((getUserType() === 'Admin' && getUserInfoType() === 'Admin') || getUserIsApprover())" 
                class="invitation__dialog_actions">
                <button 
                  v-if="(getUserType() === 'Admin' || getUserInfoType() === 'Admin' || getUserIsApprover()) &&
                        (showInvitation.rut != '' && showInvitation.rut != undefined && showInvitation.rut != null) &&
                        (showInvitation.photo != '' && showInvitation.photo != undefined && showInvitation.photo != null)" 
                  class="invitation__dialog_action_button invitation__dialog_action_button--red" 
                  @click="openModalDeny(showInvitation)">Negar</button>
                <button 
                  v-if="(getUserType() === 'Admin' || getUserInfoType() === 'Admin' || getUserIsApprover()) &&
                        (showInvitation.rut != '' && showInvitation.rut != undefined && showInvitation.rut != null) &&
                        (showInvitation.photo != '' && showInvitation.photo != undefined && showInvitation.photo != null)" 
                  class="invitation__dialog_action_button invitation__dialog_action_button--green" 
                  @click="openModalApprove(showInvitation)">Aprobar</button>
              </div>
            </div>
            <div class="invitation__dialog_body_right">
              <div 
                v-if="!isMobile" 
                class="invitation__dialog_first_field mb_1">
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Persona que invita:</strong></span>
                  <span class="color_black">{{ showInvitation.invitationBy ? showInvitation.invitationBy : '' }}</span>
                </div>
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Tipo de visitante:</strong></span>
                  <span class="color_black">{{ showInvitation.invited_type ? showInvitation.invited_type.name : '' }}</span>
                </div>
              </div>
              <div 
                v-else 
                class="invitation__dialog_first_field mb_1">
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Persona que invita:</strong></span>
                  <span class="color_black">{{ showInvitation.invitationBy ? showInvitation.invitationBy : ''  }}</span>
                </div>
                <div class="invitation__dialog_card flex_column">
                  <p style="color: black;"><strong>Fecha</strong></p>
                  <span class="invitation__dialog_dates mb_1 invitation__dialog_date"><span class="invitation__dialog_icon"><EntryIcon/></span>{{ showInvitation.date_from ? showInvitation.date_from : '' }}</span>
                  <span class="invitation__dialog_dates invitation__dialog_date"><span class="invitation__dialog_icon"><ExitIcon/></span>{{ showInvitation.date_until ? showInvitation.date_until : '' }}</span>
                </div>
              </div>
              <div 
                v-if="!isMobile" 
                class="invitation__dialog_first_field mb_1">
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Razón de la vista:</strong></span>
                  <span class="color_black">{{ showInvitation.visitReason.name ? showInvitation.visitReason.name : '_______________' }}</span>
                </div>
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Descripción:</strong></span>
                  <span class="color_black">{{ showInvitation.description ? showInvitation.description : '_______________' }}</span>
                </div>
              </div>
              <div 
                v-if="isMobile" 
                class="invitation__dialog_first_field mb_1">
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Tipo de visitante:</strong></span>
                  <span class="color_black">{{ showInvitation.invited_type ? showInvitation.invited_type.name : '' }}</span>
                </div>
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Razón de visita:</strong></span>
                  <span class="color_black">{{ showInvitation.visitReason.name ? showInvitation.visitReason.name : '_______________'  }}</span>
                </div>
              </div>
              <div 
                v-if="isMobile" 
                class="invitation__dialog_card flex_column mb_1">
                <span class="color_black mb_1"><strong>Descripción: </strong></span>
                <span class="color_black">{{ showInvitation.description ? showInvitation.description : '' }}</span>
              </div>
              <div class="invitation__dialog_first_field">
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Forma de ingreso:</strong></span>
                  <span style="display: flex; align-items: center;"><span style="width: 16px; height: 16px; display: block; margin-right: 0.5rem;"><CheckIcon/></span><span class="color_black">{{ showInvitation.vehicle_photo_url ? 'Vehicular' : 'Peatonal' }}</span></span>
                  <div 
                    style="border-top: solid 1px #b8b8b8; padding-top: 0.5rem; margin-top: 0.5rem;" 
                    v-if="showInvitation.vehicle_photo_url">
                    <div 
                      class="invitation__dialog_image" 
                      :style="{'background-image': `url(${showInvitation.vehicle_photo_url})`}"></div>
                  </div>
                </div>
                <div class="invitation__dialog_card flex_column">
                  <span class="color_black mb_1"><strong>Insumos o equipos:</strong></span>
                  <span style="display: flex; align-items: center;"><span style="width: 16px; height: 16px; display: block; margin-right: 0.5rem;"><CheckIcon/></span> <span class="color_black">{{ showInvitation.equipment_photo_url ? 'Si' : 'No' }}</span> </span>
                  <div 
                    style="border-top: solid 1px #b8b8b8; padding-top: 0.5rem; margin-top: 0.5rem;" 
                    v-if="showInvitation.equipment_photo_url">
                    <div 
                      class="invitation__dialog_image" 
                      :style="{'background-image': `url(${showInvitation.equipment_photo_url})`}"></div>
                  </div>
                </div>
              </div>
            </div>
            <div 
              class="invitation__dialog_actions" 
              v-if="isMobile && ((getUserType() === 'Admin' && getUserInfoType() === 'Admin') || getUserIsApprover())">
              <button 
                v-if="(getUserType() === 'Admin' || getUserInfoType() === 'Admin' || getUserIsApprover()) &&
                      (showInvitation.rut != '' && showInvitation.rut != undefined && showInvitation.rut != null) &&
                      (showInvitation.photo != '' && showInvitation.photo != undefined && showInvitation.photo != null)" 
                class="invitation__dialog_action_button invitation__dialog_action_button--red" 
                @click="openModalDeny(showInvitation)">Negar</button>
              <button 
                v-if="(getUserType() === 'Admin' || getUserInfoType() === 'Admin' || getUserIsApprover()) &&
                      (showInvitation.rut != '' && showInvitation.rut != undefined && showInvitation.rut != null) &&
                      (showInvitation.photo != '' && showInvitation.photo != undefined && showInvitation.photo != null)" 
                class="invitation__dialog_action_button invitation__dialog_action_button--green" 
                @click="openModalApprove(showInvitation)">Aprobar</button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog
        v-model="modal_deny"
        persistent
        max-width="500px"
        max-height="300px"
    >
      <v-card>
        <div class="invitation__new">
          <div class="invitation__new--title">
            <p class="invitation__new_text--title">
              Razón para denegar
            </p>
          </div>
          <p class="invitation__new_text--subtitle">Seleccione los criterios con los que incumple la invitación:</p>

          <v-container>
              <div 
                v-for="reason in rejection_reasons" 
                :key="reason.id" cols="12">
                <v-checkbox 
                  v-model="selected_reasons" 
                  :label="reason.name" 
                  :value="reason.id" 
                  v-if="reason.status" dense ></v-checkbox>
              </div>
          </v-container>
          <v-card-text style="padding-top: 0; padding-bottom: 0;">
            <v-textarea
                v-model="reason_for_denied"
                label="Detalles"
                rows="2"
                class="invitation__new--textarea"
                style="margin-top: 10px"
            >
            </v-textarea>
          </v-card-text>

          <!-- Input de archivos con estilo -->
          <div class="file-upload-container" >
            <label 
              for="file-upload" 
              class="file-upload-label" >Subir archivos</label>
            <input
              id="file-upload"
              type="file"
              multiple
              @change="handleFileUpload"
              class="file-upload-input"
              ref="fileInput"
            />

            <div 
              v-if="attachments.length" 
              class="file-list">
              <p 
                v-for="(file, index) in attachments" 
                :key="index" 
                class="file-item">
                {{ file.name }} ({{ (file.size / 1024).toFixed(2) }} KB)
              </p>
            </div>
          </div>


          <div class="invitation__new--info_container">
            <div class="invitation__new--actions">
              <v-btn @click="closeModalDeny">CANCELAR</v-btn>
              <v-btn v-if="(selected_reasons.length > 0 || rejection_reasons.length==0) && reason_for_denied"
                  color="info"
                  @click="deniedInvitation()"
              >DENEGAR
              </v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </article>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import ApproveIcon from "../../shared/icons/ApproveIcon.vue";
import ViewIcon from "../../shared/icons/ViewIcon.vue";
import invitations_services from "../../../services/invitations_services";
import invitationTypesService from "../../../services/InvitationTypeService";
import DeleteIcon from "../../shared/icons/DeleteIcon.vue";
import Hammer from "hammerjs";
import Vue from "vue";
import UserIcon from "../../shared/icons/UserIcon.vue";
import ExitIcon from "../../shared/icons/ExitIcon.vue";
import EntryIcon from "../../shared/icons/EntryIcon.vue";
import BuildingIcon from "../../shared/icons/BuildingIcon.vue";
import {mapState} from "vuex";
import AddIcon from "../../shared/icons/AddIcon.vue";
import CheckIcon from "../../shared/icons/CheckIcon.vue";

Vue.directive("swipe", {
  bind(el, binding) {
    const hammer = new Hammer(el);
    hammer.get("pan").set({ direction: Hammer.DIRECTION_HORIZONTAL });

    const { threshold = 100, active = true } = binding.value || {};

    let startY = 0;
    let startX = 0;
    let isHorizontalSwipe = false;

    hammer.on("panstart", (event) => {
      startY = event.center.y;
      startX = event.center.x;
      isHorizontalSwipe = false;
    });

    hammer.on("pan", (event) => {
      const deltaY = Math.abs(event.center.y - startY);
      const deltaX = Math.abs(event.center.x - startX);
      if (!isHorizontalSwipe) {
        isHorizontalSwipe = deltaX > deltaY;
      }
      if (!active || !isHorizontalSwipe) return;
      el.style.transform = `translateX(${event.deltaX}px)`;
    });

    hammer.on("panend", (event) => {
      if (!isHorizontalSwipe || !active) return;

      if (event.deltaX > threshold) {
        el.dispatchEvent(new CustomEvent("swipe-right"));
        el.style.transition = "transform 0.3s ease-out";
        el.style.transform = `translateX(${threshold}px)`;
      } else if (event.deltaX < -threshold) {
        el.dispatchEvent(new CustomEvent("swipe-left"));
        el.style.transition = "transform 0.3s ease-out";
        el.style.transform = `translateX(${-threshold}px)`;
      } else {
        el.style.transition = "transform 0.3s ease-out";
        el.style.transform = "translateX(0px)";
      }
      setTimeout(() => {
        el.style.transition = "";
      }, 300);
    });
  }
});


export default {
  data() {
    return {
      steps:[{name: "Usuario", state: "Completed"},
             {name: "Seguridad Fisica", state: "Completed"},
             {name: "SSO", state: "Cancelled"},
             {name: "Departamento", state: "Pending"}],
      invitations: [],
      headerOptions: [
        {id: 1, title: 'Aprobar', class: 'invitation__blue_circle'},
        {id: 2, title: 'Visita activa', class: 'invitation__green_circle'},
        {id: 3, title: 'Salidas', class: 'invitation__red_circle'},
        {id: 4, title: 'Sin Foto', class: 'invitation__gray_circle'},
      ],
      invitationTypes: [],
      selectedState: 1,
      positioned: false,
      dividerHeader: 50,
      maxWidth: 900,
      isMobile: false,
      dates: [],
      panel: 0,
      uploadedPhoto: null,
      timePickerKey: 0,
      fieldEnabled: false,
      cameraOpen: false,
      stream: null,
      user_info_type: "",
      selectedInvitation: {},
      modal_deny: false,
      modal_approve: false,
      modal_info: false,
      modal_hour_error: false,
      modal_photo_error: false,
      reason_for_denied: "",
      show_init_time_picker: false,
      show_finish_time_picker: false,
      saved_default_option: false,
      modal_create: false,
      edit_photo_modal: false,
      modal_cancel: false,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      select: [],
      menu: false,
      menu2: false,
      menunew: false,
      menu2new: false,
      datePickerFirstClick: false,
      datePickerFirstClick2: false,
      pages: 2,
      pagination: {page: 1, rowsPerPage: 10},
      groupedInvitations: {},
      loaded: false,
      newemail: "",
      newlocation: "",
      locations: [],
      selectedLocation: null,
      isLoading: false,
      showInvitation: null,
      rejection_reasons:[],
      selected_reasons:[],
      attachments:[],
      //Pagination data
      totalItems: null,
      totalPages: 0,
      initialLoading: true,
      selectedPage: 1,
    };
  },
  components: {
    ViewIcon,
    ApproveIcon,
    VueTimepicker,
    DeleteIcon,
    UserIcon,
    ExitIcon,
    EntryIcon,
    AddIcon,
    BuildingIcon,
    CheckIcon,
   },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
    this.unsubscribeFromInvitationsChannel();
  },
  methods: {
    handleFileUpload(event) {
        const files = event.target.files;

        Array.from(files).forEach(file => {
            if (file.size > 1024 * 1024) { // 1MB en bytes
                alert(`El archivo "${file.name}" excede el tamaño máximo de 1MB y no será agregado.`);
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.attachments.push({
                    name: file.name,
                    content: e.target.result, // Mantiene el prefijo data:text/plain;base64,
                });
            };

            reader.readAsDataURL(file); // Convertimos a base64 con prefijo incluido
        });
    },
    updateWidth() {
      const isMobile = window.innerWidth < 1024;
      setTimeout(async () => {
        if (JSON.parse(JSON.stringify(isMobile)) !== this.isMobile) {
          console.log('update width');
          await this.getInvitations();
        }
        this.isMobile = isMobile;
        this.dividerHeader = this.$refs.contentHeader && this.$refs.contentHeader.offsetHeight ? this.$refs.contentHeader.offsetHeight : 0;
        this.positioned = true;
      }, 500);
    },
    onModalOpen() {
      this.$router.push({
        name: "invitation_create",
      })
    },
    openModalDeny(invitation) {
      this.selectedInvitation = invitation;
      this.modal_deny = true;
    },
    closeModalDeny() {
      this.modal_deny = false;
      this.reasonForDenial = "";
      this.selected_reasons = [];
      this.attachments = [];
      this.reason_for_denied="";
    },
    openModalApprove(invitation) {
      if (!invitation.photo) {
        alert('La invitación no puede ser aprobada, Falta la foto!')
        return;
      }
      this.selectedInvitation = invitation;
      this.modal_approve = true;
    },
    approveInvitation() {
      let invitation = this.selectedInvitation;
      let depApprover = false;
      if(this.getUserIsApprover()){
        depApprover = true;
      }

      let data = {
        id: this.getUserId(),
        company_id: this.getCompany().id,
        approve_invitation_id: invitation.id,
        dep_approved: depApprover
      };
      const vm = this;
      try {
        invitations_services.approveInvitation(this.encrypt(data).toString())
          .then((response) => {
            vm.modal_approve = false;
            if (response.status === 200) {
              vm.getInvitations();
              vm.selectedInvitation = null;
              vm.modal_info = false;
              alert('Invitación aprobada');
            } else if (response.status === 500) {
              alert("Ocurrió un error inesperado. Por favor intente nuevamente.");
            }
          })
          .catch((error) => {
            vm.modal_approve = false;
            console.error("Error en la solicitud:", error);

            if (error.response && error.response.status === 500) {
              alert("Ocurrió un error inesperado. Por favor intente nuevamente.");
            } else {
              console.log(error)
              alert(error.body.errors[0].title + ', '+ error.body.errors[0].details);
              this.getInvitations();
            }
          });
      } catch (e) {
        alert("Ocurrió un error inesperado. Por favor intente nuevamente.");
        console.error(e);
      }
    },
    deniedInvitation() {


      let invitation = this.selectedInvitation;
      let depApprover = false;
      if(this.getUserIsApprover()){
        depApprover = true;
      }


      this.modal_deny = false;

      let data = {
        deny_invitation_id: invitation.id,
        reason_for_denied: this.reason_for_denied,
        id: this.getUserId(),
        dep_approved: depApprover,
        rejected_reasons_ids: this.selected_reasons,
        files: this.attachments
      };

      const vm = this;
      try {
        invitations_services.deniedInvitation(this.encrypt(data).toString())
          .then(function (response) {
            if (response.status === 200) {
              vm.getInvitations();
              vm.selectedInvitation = null;
              vm.modal_info = false;
              alert(response.body.message);
            } else {
              alert(response.body.message);
              console.error(response.body.error);
            }
          })
          .catch((error) => {
            this.modal_approve = false;
            console.error("Error en la solicitud:", error);

            if (error.response && error.response.status === 500) {
              alert("Ocurrió un error inesperado. Por favor intente nuevamente.");
            } else {
              console.log(error)
              alert(error.body.errors[0].title + ', '+ error.body.errors[0].details);
              this.getInvitations();
            }
          });;
      } catch (e) {
        alert("Ocurrió un error inesperado. Por favor intente nuevamente.");
        console.error(e);
      }
      this.selected_reasons = [];
      this.attachments = [];
      this.reason_for_denied=""
      },
    modifyDateFormatToStatus() {
      let entries = dates.split("/");
      entries = [entries[2], entries[0], entries[1]];
      return entries.join("-");
    },
    async getInvitations() {
      try {
        const data = await invitations_services.getInvitations(this.buildParams());
        this.invitations = data.data;
        this.totalItems = data.pagination.total_records;
        this.totalPages = data.pagination.total_pages;
        this.groupInvitations(data.data);
      } catch (e) {
        console.error(e);
      }
    },
    getInvitationState(id) {
      const states = {
        1: 'PENDING',
        2: 'ACTIVE',
        3: 'EXPIRED',
        4: 'WITHOUT_PHOTO',
      };
      return states[id] ? states[id] : 'PENDING';
    },
    async getCompanyLocations() {
      const data = {company: {id: this.getCompany().id}};
      try {
        const resp = await this.$http.post("locations/get_all_company_locations", {
            data: this.encrypt(data).toString(),
          },
          {headers: {"Content-Type": "application/json"}})
        this.locations = [{id: null, name: "General"}, ...resp.body.data];
      } catch (e) {
        alert(e);
      }
    },
    async get_rejection_reasons() {

      try {
        const response  = await this.$http.get("invited_client/rejection_reasons", {
          params: {
            company_id: this.getCompany().id,
            id: this.getUserId()
          }
        });
        this.rejection_reasons = response.data.map(({ id, name, status }) => ({ id, name, status }));
      } catch (err) {
        console.error(err);
      }
    },
    checkInvitationState(id){
      this.steps = []
      this.$http.get("invited_client/check_invitation_state", {
        params: {
          id: id
        }
      })
      .then(response => {
        this.steps = response.data;
      })
      .catch(error => {
        console.error("Error fetching invitation state:", error);
      });
    },
    showData(invitation) {
      this.showInvitation = invitation;
      this.modal_info = true;
      this.checkInvitationState(invitation.id);
    },
    closeData() {
      this.modal_info = false;
      this.showInvitation = null;
    },
    groupInvitations(invitations = []) {
      const temp = [...invitations];
      temp.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
      const keys = [];
      const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const monthName = date.toLocaleString('es-ES', {month: 'long'});
        const year = date.getFullYear();
        return {
          key: `${day}_${month}_${year}`,
          label: `${day}/${month}`,
          full: `${day} de ${monthName}`,
          weekDay: `${date.toLocaleDateString('es-ES', {weekday: 'short'})}`,
          day,
        }
      }
      let grouped = {};
      temp.forEach(item => {
        const dateItem = formatDate(new Date(item.start));
        if (!(dateItem.key in grouped)) {
          keys.push(dateItem);
          grouped[dateItem.key] = [];
        }
        grouped[dateItem.key].push(item);
      });
      this.dates = keys;
      this.groupedInvitations = grouped;
    },
    goToDate(selector) {
      const element = document.getElementById(selector);
      const header = this.$refs.headerFixed;
      const headerHeight = header ? header.offsetHeight : 0;

      if (!element) return;

      const elementPosition = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - headerHeight - 230,
        behavior: "smooth"
      });
    },
    selectState(value) {
      if (value === this.selectedState) return;
      this.selectedState = value;
      this.initialLoading = true;
      this.selectedPage = 1;
      this.invitationTypes.forEach(item => item.selected = false);
      this.getInvitations();
    },
    getInvitationTypes() {
      const params = {
        'data[user_id]': this.getUserId(),
      }
      invitationTypesService.getInvitationTypes(params).then(resp => {
        this.invitationTypes = resp.data.data.map(item => {
          return {
            id: item.id,
            title: item.attributes.name,
            selected: false,
          }
        });
      });
    },
    copyRut(rut, event) {
      event.stopPropagation();
      navigator.clipboard.writeText(rut).then(() => {
      }).catch(err => {
        console.error(err);
      });
    },
    buildParams() {
      if (this.isMobile) {
        return {
          id: this.getUserId(),
          status: this.getUserIsApprover() ? "approved" :"active",
          invitation_state: "ACTIVE",
          limit: 24,
          offset: (this.selectedPage -1) * 24,
          filter_state: 'ALL',
        }
      } else {
        const types = this.invitationTypes.filter(item => item.selected).map(item => item.id);
        return {
          id: this.getUserId(), status: this.getUserIsApprover() ? "approved" :"active",
          invitation_state: "ACTIVE",
          limit: 24,
          offset: (this.selectedPage - 1) * 24,
          filter_state: this.getInvitationState(this.selectedState),
          location_id: this.selectedLocation ? this.selectedLocation.id : undefined,
          invitation_type: types.length > 0 ? types : undefined,
        }
      }
    },
    async updateType() {
      this.selectedPage = 1;
      await this.getInvitations();
    },
    async updatePagination() {
      await this.getInvitations();
    },
    async selectLocation() {
      this.selectedPage = 1;
      await this.getInvitations();
    },
    subscribeToInvitationsChannel() {
      this.$cable.subscribe({
        channel: 'ApprovalInvitationsChannel',
        room: `room_approval_invitations_${this.getUserId()}`,
        approval_user_id: this.getUserId()
      })
    },
    unsubscribeFromInvitationsChannel() {
      this.$cable.unsubscribe("ApprovalInvitationsChannel");
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateWidth);
    this.isMobile = window.innerWidth < 1024;
    setTimeout(async () => {
      let roles= this.getUserRoles();
      if(!roles.includes('counter') || roles.length > 1){
        this.get_rejection_reasons();
      }
      await this.getInvitationTypes();
      await this.getCompanyLocations();
      await this.getInvitations();
      this.positioned = true;
      this.subscribeToInvitationsChannel();
    }, 1000);
  },
  channels: {
    ApprovalInvitationsChannel: {
      received(data) {
        console.log(data);
        this.selectedPage = 1;
        this.getInvitations();
      }
    }
  }
};
</script>
<style>
.vue__time-picker .dropdown ul li:not([disabled]).active {
  background-color: #1476fb !important;
}

.table_card__body.v-input > input {
  background-color: #1476fb !important;
}

.formatted-date .time {
  font-weight: bold;
  font-size: 16px;
}

.formatted-date .date {
  font-size: 14px;
  color: #666;
}

@media screen and (min-width: 1024px) {
  .card-container {
    padding: 1rem 0;
  }
}

.card-container p {
  font-size: 16px;
  height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
}

p {
  font-size: 16px;
}

.card {
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
  .card-content {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 30%;
    background: #f2f2f2;
    padding: 1.5rem 1rem;
    gap: 1rem;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

  img {
    height: 120px;
  }
}
}


.cards-container {

  p {
    font-size: 14px!important;
  }

  width: 100%;
  overflow: hidden;

  > div > * {
    border-bottom: solid 1px #3c3c3c;
  }

  .card-content {
    width: 100%;
    background-color: white;
    padding: 1rem;
    z-index: 2;
    position: relative;
    display: flex;
    border-radius: 0;
    overflow: hidden;
    gap: 0;
  }

  .card {
    background: rgba(202, 202, 202, 0.548);
    width: 100%;
    overflow-x: hidden;
    border-radius: 0;
  }
}


.deny_button {
  border: solid 1px red;
  color: red;
  padding: 1rem 1.5rem;
  background: white;
  &:hover {
    color: white;
    background: red;
  }
}

.custom-dialog {
  border-radius: 12px 12px 0 0!important;
  height: 90%;
}

@media screen and (max-width: 1024px) {
  .custom-dialog {
    margin: 0!important;
    bottom: 0;
    position: absolute;
    height: 95%!important;
    max-height: unset!important;
  }
}

.disabled-button {
  cursor: unset!important;
  border: solid 1px #3c3c3c!important;
  background: white;
  color: #3c3c3c!important;
  &:hover {
    background: white;
  }
}

.check-box {
  border: solid 1px rgb(178 178 178);
  width: 16px;
  height: 16px;
  margin-right:
  0.5rem;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  &::after {
    position: absolute;
    content: "";
    height: 2px;
    display: block;
    background: rgb(178 178 178);
    width: 80%;
    transform: rotate(-45deg);
  }
  &::before {
    position: absolute;
    content: "";
    height: 2px;
    display: block;
    background: rgb(178 178 178);
    width: 80%;
    transform: rotate(45deg);
  }
}

.close-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  border: solid 1px white;
  margin-right: 0.5rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  &::before {
    content: "";
    position: absolute;
    height: 1px;
    background: white;
    width: 75%;
    transform: rotate(-45deg);
  }
  &::after {
    content: "";
    position: absolute;
    height: 1px;
    background: white;
    width: 75%;
    transform: rotate(45deg);
  }
}

.dates_header {
  display: flex;
  margin-bottom: 1rem;
  font-size: 14px;
  overflow: auto;
  padding-bottom: 0.4rem;
  scrollbar-width: thin;
}

.chip {
  margin-right: 0.7rem;
  padding: 0.8rem 0.5rem;
  cursor: pointer;
  background: #0176fb;
  color: white;
  border-radius: 10px;
}


.file-upload-container {
  margin: 0px 20px
}


.file-upload-input {
  display: none;
}

.file-list {
  margin-top: 10px;
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.file-item {
  font-size: 14px;
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;
}

.file-item:last-child {
  border-bottom: none;
}

.file-item::before {
  content: "📄";
  margin-right: 5px;
}

.file-upload-label {
  font-size: 16px;
  font-weight: bold;
  color: #3498db;
  display: inline-block;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 5px;
  background: #ecf6ff;
  transition: background 0.3s ease;
}

.file-upload-label:hover {
  background: #d6ebff;
}

.v-stepper i{
  color:#fff !important;
}


</style>




// WEBPACK FOOTER //
// src/components/views/invitations/InvitationsIndex.vue